export default {
  emptyCart: {
    code: 1000,
  },
  sessionExpired: {
    code: 1010,
    message: 'Ваша сессия устарела. Пожалуйста, обновите страницу',
  },
};
